import React from 'react';

const ArrowDown = () => (
  <svg id="ic_down" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 125">
    <path d="M97.137,29.56C97.714,28.984,98,28.229,98,27.475s-0.286-1.51-0.863-2.085c-1.152-1.152-3.018-1.152-4.169,0L50,68.356  L7.031,25.39c-1.149-1.152-3.015-1.152-4.169,0c-1.15,1.152-1.15,3.018,0,4.17L47.917,74.61c1.15,1.152,3.015,1.152,4.17,0  L97.137,29.56z"></path>
  </svg>
);

export default ArrowDown;



// WEBPACK FOOTER //
// ./src/asset/ArrowDown.js